import { Tooltip as TooltipView } from './Tooltip.view';
export * from './Tooltip.view';

export const Tooltip = (props) => TooltipView(props);

export default Tooltip;

